import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

function AddRoleUser({ userID }) {
  const history = useHistory();

  const [roleUserData, setRoleUserData] = useState({
    role: null,
    reason_ban: "",
  });
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    initRoleUser();
  }, []);

  const initRoleUser = async () => {
    await getRoleUser(userID);
    await getRoles();
  };

  const getRoleUser = async (userID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const roleData = await sendRequestGetRoleUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setRoleUserData(roleData);
  };

  const sendRequestGetRoleUser = async (userID) => {
    const headersRequest = getHeaderRequest();
    let resultGetRoleIDUser;
    try {
      resultGetRoleIDUser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/get-role-user/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return resultGetRoleIDUser.data.data;
  };

  const getRoles = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setRoles(await sendRequestGetRoles());
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    // setTagRoles(generateTagRoles(roles));
  };

  const generateTagRoles = (roles) => {
    let tgasRole;

    tgasRole = roles.map((role, index) => {
      let selected;
      if (roleUserData.role == role.rol_id) {
        selected = "selected";
      }

      return (
        <option selected={selected} value={role.rol_id} key={index}>
          {role.rol_persian_name}
        </option>
      );
    });

    return tgasRole;
  };

  const sendRequestGetRoles = async () => {
    const headersRequest = getHeaderRequest();
    let roles = await httpService.getRequest(
      process.env.REACT_APP_DOMAIN_API + "/v1/role",
      headersRequest
    );

    return roles.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const slecetTagRole = document.getElementById("roles");
    const roleID = slecetTagRole.options[slecetTagRole.selectedIndex].value;
    const roleText = slecetTagRole.options[slecetTagRole.selectedIndex].text;
    let reasonBan = null;
    if (roleText == "کاربر مسدود شده") {
      reasonBan = document.querySelector("#reason-ban").value;
    }

    const dataRequest = JSON.stringify({
      reason_ban: reasonBan,
    });
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestToAddRoleUser(roleID, dataRequest);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/user/all");
  };

  const sendRequestToAddRoleUser = async (roleID, dataRequest) => {
    const headersRequest = getHeaderRequest();

    try {
      return await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/auth/add-role-user/" +
          roleID +
          "/" +
          userID,
        dataRequest,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <div>
      <div className="col-12 col-lg-6">
        <div className="form-group">
          <form onSubmit={submitForm}>
            <label>نقش کاربر</label>
            <select className="form-control" id="roles">
              {/* {tagRoles} */}
              {generateTagRoles(roles)}
            </select>
            <br />
            <textarea
              className="form-control"
              id="reason-ban"
              placeholder="دلیل مسدود شدن حساب کاربر را بنویسید"
              defaultValue={roleUserData.reason_ban}
            ></textarea>
            <br />
            <button types="submit" className="btn btn-primary">
              اعمال
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddRoleUser;
